(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDialogController', OfficePhoneDialogController);

    /* Added $filter
    OfficePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfficePhone'];

    function OfficePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfficePhone) {
    */
    OfficePhoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OfficePhone', '$filter'];

    function OfficePhoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OfficePhone, $filter) {
        var vm = this;

        vm.officePhone = entity;
        vm.clear = clear;
        vm.save = save;
        vm.calcProps = calcProps;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.officePhone.id !== null) {
                OfficePhone.update(vm.officePhone, onSaveSuccess, onSaveError);
            } else {
                OfficePhone.save(vm.officePhone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:officePhoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function calcProps() {
            if (vm.officePhone.number == null || vm.officePhone.caption == null) {
                return;
            }
            var phone = $filter('phone')(vm.officePhone.number, '');
            // refers to ru.inquarta.telestat.domain.util.PropsStringUtils.DEFAULT_PHONE_CODES_STR
            phone = phone.replace(/^\+7\(861\)|\+7\(988\)/, '');
            vm.officePhone.title = vm.officePhone.caption + " " + phone;
        }

    }
})();
